import { render, staticRenderFns } from "./DashboardsCus.vue?vue&type=template&id=8e656488&scoped=true&"
import script from "./DashboardsCus.vue?vue&type=script&lang=js&"
export * from "./DashboardsCus.vue?vue&type=script&lang=js&"
import style0 from "./DashboardsCus.vue?vue&type=style&index=0&id=8e656488&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e656488",
  null
  
)

export default component.exports